import { CalendarNativeDateFormatter, DateFormatterParams } from "angular-calendar";

export class DemoModule extends CalendarNativeDateFormatter {
    public weekViewHour({ date, locale }: DateFormatterParams): string {
      return new Intl.DateTimeFormat('es-MX', {
        hour: 'numeric',
        minute: 'numeric',
      }).format(date);
    }
  }